/**
 * Matches the backend's fixed response envelope. Every API response (success
 * or error) is wrapped in this shape. See packages/api/src/client/api-client.ts
 * for the code that unwraps it.
 */
export interface ApiErrorPayload {
  code: string;
  message: string;
}

export interface ApiResponse<T> {
  success: boolean;
  statusCode: number;
  data: T | null;
  error: ApiErrorPayload | null;
  timestamp: string;
  path: string;
}

/**
 * Thrown by the api-client whenever the backend envelope reports
 * `success: false`, or when the request fails outright (network error,
 * non-JSON response, etc).
 */
export class ApiError extends Error {
  readonly code: string;
  readonly statusCode: number;

  constructor(payload: ApiErrorPayload, statusCode: number) {
    super(payload.message);
    this.name = "ApiError";
    this.code = payload.code;
    this.statusCode = statusCode;
  }
}
